import React, { useState } from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TextField,
    Select,
    MenuItem,
    Switch
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import SaveIcon from "@mui/icons-material/Save";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import HistoryIcon from "@mui/icons-material/History";
import { useNavigate } from "react-router-dom";
import EditText from "../../../components/editText";
import IconButton from "@mui/material/IconButton";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Button from "@mui/material/Button";
import "./editContract.scss";

export default function EditContract() {
    const navigate = useNavigate();
    const [templateName, setTemplateName] = useState("Vendor Service Agreement");
    const [jurisdiction, setJurisdiction] = useState("United Arab Emirates - English");
    const [scope1, setScope1] = useState("<p>This Vendor Service Agreement (\"Agreement\") is entered into between [Platform Name] (\"Bouteek\", \"Platform\") and the Vendor listed below. This Agreement governs the terms under which the Vendor.</p><p>By entering into this Agreement, the Vendor acknowledges and agrees that all information provided is accurate and legally valid, national, and international laws, regulations, and industry standards relevant to operations.</p>");
    const [scope2, setScope2] = useState("<p>This Vendor Service Agreement (\"Agreement\") is entered into between [Platform Name] (\"Bouteek\", \"Platform\")</p>");

    return (
        <div className="edit_contract_page">
            <div className="main_header">
                <h1>Create / Edit Vendor Contract Template</h1>
                <p className="help_text">
                    Use this template to create vendor contracts. Customize the sections, clauses, and clauses as needed. Use variables like [Vendor Name] or [Effective Date] as placeholders. Learn more.
                </p>
            </div>

            <div className="edit_layout">
                {/* Main Content Area */}
                <div className="main_content_area">
                    <div className="details_card">
                        <h2>Contract Details</h2>
                        <div className="fields_row">
                            <div className="field_group">
                                <label htmlFor="contract-template-name">Template Name:</label>
                                <TextField
                                    value={templateName}
                                    onChange={(e) => setTemplateName(e.target.value)}
                                    size="small"
                                    fullWidth
                                    inputProps={{ id: "contract-template-name" }}
                                />
                            </div>
                            <div className="version_badge">
                                Latest Version: <strong>v1.2</strong>
                                <IconButton size="small"><CloseIcon fontSize="small" /></IconButton>
                            </div>
                            <div className="field_group">
                                <label htmlFor="contract-jurisdiction">Contract Jurisdiction:</label>
                                <Select
                                    value={jurisdiction}
                                    onChange={(e) => setJurisdiction(e.target.value)}
                                    size="small"
                                    fullWidth
                                    inputProps={{ id: "contract-jurisdiction" }}
                                >
                                    <MenuItem value="United Arab Emirates - English">United Arab Emirates - English</MenuItem>
                                    <MenuItem value="USA - English">USA - English</MenuItem>
                                </Select>
                            </div>
                        </div>
                    </div>

                    <div className="clause_section">
                        <Accordion defaultExpanded>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <div className="summary_content">
                                    <div className="left_p">
                                        <span className="num">1</span> Scope of Services
                                    </div>
                                 
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <EditText content={scope1} setContent={setScope1} />
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <div className="summary_content">
                                    <div className="left_p">
                                        <span className="num">2</span> Scope of Services
                                    </div>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <EditText content={scope2} setContent={setScope2} />
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>

                {/* Sidebar area */}
                <div className="sidebar_area">
                 

                 
                    <div className="audit_card">
                        <div className="audit_head">
                            <h3>Audit Trail</h3>
                            <ExpandMoreIcon />
                        </div>

                        <div className="current_v">
                            <CheckCircleOutlineIcon /> Current Version: v2
                        </div>

                        <div className="audit_log">
                            <div className="log_item">
                                <span className="v_num">v1.2</span>
                                <span className="u_name">Ahmed Jamal</span>
                                <small className="u_desc">• Updated compliance requirements</small>
                                <small className="u_desc">• Continued use clausel</small>
                            </div>
                            <div className="log_item">
                                <span className="v_num">v1.1</span>
                                <span className="u_name">Sarah Mathews</span>
                                <small className="u_desc">• Initial version created</small>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Sticky Footer */}
            <div className="sticky_footer">
                <div className="left_btns">
                    <button onClick={() => navigate("/vendor-comtracts")}>✕ Cancel</button>
                </div>
                <div className="center_btns">
                    <button className="save_main">Preview & Save Template</button>
                </div>
              
            </div>
        </div>
    );
}
